import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import map from 'lodash/map'
import orderBy from 'lodash/orderBy'

import usePagination from 'firestore-pagination-hook'
import {db} from 'configs/firebase'

import {timestampConverter} from 'utils/db.utils'
import useAuthStateWithAnonymousSignIn from 'hooks/useAuthStateWithAnonymousSignIn'

import ChatBoxView from './View'

const MESSAGES_LIMIT = 40

const ChatBox = ({
  room,
  pin,
  encryptionKeys,
  keyManager,
  userName,
  showDetailsOnLoad,
}) => {
  const roomId = get(room, 'uid')
  const messagesDbRef = db
    .collection(`chats/${roomId}/messages`)
    .orderBy('createdAt', 'desc')
    .withConverter(timestampConverter)

  const [user, isLoadingUser] = useAuthStateWithAnonymousSignIn()

  const {
    loading: isLoadingMessages,
    loadingError: hasMessagesLoadingError,
    loadingMore: isLoadingMoreMessages,
    hasMore: hasMoreMessages,
    items,
    loadMore,
  } = usePagination(roomId ? messagesDbRef : null, {limit: MESSAGES_LIMIT})

  // @TODO:
  // this is not efficient, however the usePagination hook
  // does not respect the orderBy while adding the field.
  // investigate further!!
  const messages = useMemo(
    () =>
      orderBy(
        map(items, item => item.data()),
        ['createdAt'],
        ['desc']
      ),
    [items]
  )

  return (
    <ChatBoxView
      room={room}
      pin={pin}
      encryptionKeys={encryptionKeys}
      keyManager={keyManager}
      user={{uid: get(user, 'uid'), name: userName}}
      messages={messages}
      showDetailsOnLoad={showDetailsOnLoad}
      isLoading={isLoadingMessages || isLoadingUser}
      isLoadingMoreMessages={isLoadingMoreMessages}
      haError={hasMessagesLoadingError}
      hasMoreMessages={hasMoreMessages}
      onClickLoadMoreMessages={loadMore}
    />
  )
}

ChatBox.propTypes = {
  encryptionKeys: PropTypes.shape({
    public: PropTypes.string,
    private: PropTypes.string,
  }),
  keyManager: PropTypes.object.isRequired,
  pin: PropTypes.string,
  room: PropTypes.shape({
    createdAt: PropTypes.number,
    description: PropTypes.string,
    creator: PropTypes.shape({
      uid: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  showDetailsOnLoad: PropTypes.bool,
  userName: PropTypes.string.isRequired,
}

export default ChatBox
